import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import autoShowModal from '../modifiers/auto-show-modal.js';
import Icon from './icon.gjs';
import { faCircleInfo, faXmark } from '../icons/solid';

<template>
  <dialog
    class="modal"
    {{autoShowModal}}
    {{on "cancel" @onClose}}
    {{on "close" @onClose}}
  >
    <form
      aria-label="modal"
      method="dialog"
      class="modal-box max-h-3/4 flex flex-col"
      ...attributes
    >
      <div class="flex items-center space-x-2 mb-4">
        <Icon class="text-info" @icon={{faCircleInfo}} @size="2xl" />
        <h3 class="text-xl text-info font-bold flex-1">
          {{or @title (t "help")}}
        </h3>
        <button
          type="button"
          class="btn btn-square btn-ghost btn-sm"
          {{on "click" @onClose}}
        >
          <Icon @icon={{faXmark}} />
        </button>
      </div>

      <article class="flex-1 overflow-auto prose">
        {{#if @content}}
          {{@content}}
        {{else}}
          {{yield}}
        {{/if}}
      </article>
    </form>
    <form aria-label="backdrop" method="dialog" class="modal-backdrop">
      <button type="submit">{{t "close"}}</button>
    </form>
  </dialog>
</template>
